<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">宠物中心</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠物管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">宠物档案管理</span></h2>
      <div class="header-actions">
        <el-input v-model="searchQuery" placeholder="搜索宠物名" clearable prefix-icon="Search" style="width:180px" @input="fetchData"/>
        <el-select v-model="filterCategory" placeholder="品类筛选" clearable style="width:130px" @change="fetchData">
          <el-option v-for="c in categories" :key="c" :label="c" :value="c"/>
        </el-select>
        <el-button type="primary" @click="showDialog(false)">新增档案</el-button>
      </div>
    </div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="姓名" prop="name" min-width="100"/>
      <el-table-column label="头像" width="70">
        <template #default="{row}"><el-image v-if="row.avatar" :src="row.avatar" style="width:40px;height:40px;border-radius:50%" fit="cover"/><span v-else>-</span></template>
      </el-table-column>
      <el-table-column label="品类 / 品种" min-width="140">
        <template #default="{row}">
          <span>{{row.category || '-'}}</span>
          <span v-if="row.sub_category" class="sub-cat-sep">/</span>
          <span v-if="row.sub_category" class="sub-cat">{{row.sub_category}}</span>
        </template>
      </el-table-column>
      <el-table-column label="性别" width="60">
        <template #default="{row}">
          <el-tag :type="row.gender === 'male' ? 'primary' : 'danger'" size="small">{{genderMap[row.gender] || '-'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="绝育" width="60">
        <template #default="{row}"><el-tag :type="row.is_neutered?'success':'info'" size="small">{{row.is_neutered?'已绝育':'未绝育'}}</el-tag></template>
      </el-table-column>
      <el-table-column label="生日" width="110"><template #default="{row}">{{row.birthday ? row.birthday.substring(0,10) : '-'}}</template></el-table-column>
      <el-table-column label="攻击性" width="100" align="center">
        <template #default="{row}">
          <el-tag v-if="row.aggressive_to_pets" type="warning" size="small" effect="plain">对宠物</el-tag>
          <el-tag v-if="row.aggressive_to_humans" type="warning" size="small" effect="plain">对人</el-tag>
          <span v-if="!row.aggressive_to_pets && !row.aggressive_to_humans" class="text-muted">无</span>
        </template>
      </el-table-column>
      <el-table-column label="用户" min-width="120"><template #default="{row}">{{row.user?.name||row.user_id}}</template></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{row}">
          <el-button size="small" @click="showDialog(true,row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="dialogVisible" :title="isEdit?'编辑档案':'新增档案'" width="600px">
      <el-form ref="formRef" :model="form" :rules="{name:[{required:true,message:'请输入宠物姓名'}]}" label-width="110px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="宠物姓名" prop="name"><el-input v-model="form.name"/></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像"><Upload v-model="form.avatar" :max-count="1" :width="100" :height="100" tip="推荐尺寸 宽 160 × 高 160 px" /></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="品类">
              <el-input v-model="form.category" placeholder="如：狗、猫"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品种">
              <el-input v-model="form.sub_category" placeholder="如：金毛、布偶"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="性别">
              <el-select v-model="form.gender" style="width:100%">
                <el-option label="公" value="male"/>
                <el-option label="母" value="female"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生日"><el-date-picker v-model="form.birthday" type="date" value-format="YYYY-MM-DD" style="width:100%"/></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="绝育"><el-switch v-model="form.is_neutered"/></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="驱虫时间"><el-date-picker v-model="form.deworming_date" type="date" value-format="YYYY-MM-DD" style="width:100%"/></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="疫苗时间"><el-date-picker v-model="form.vaccination_date" type="date" value-format="YYYY-MM-DD" style="width:100%"/></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="对宠物有攻击性"><el-switch v-model="form.aggressive_to_pets"/></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对人有攻击性"><el-switch v-model="form.aggressive_to_humans"/></el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as api from '../../api/petProfile'
import Upload from '../../components/Upload.vue'

const list = ref([])
const loading = ref(false)
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 })
const saving = ref(false)
const dialogVisible = ref(false)
const isEdit = ref(false)
const searchQuery = ref('')
const filterCategory = ref('')
const categories = ref([])

// 枚举 -> 中文
const genderMap = { male: '公', female: '母' }

const defaultForm = () => ({
  name: '', avatar: '', category: '', sub_category: '',
  gender: 'male', birthday: null, is_neutered: false,
  deworming_date: null, vaccination_date: null,
  aggressive_to_pets: false, aggressive_to_humans: false,
})

const form = ref(defaultForm())
const formRef = ref(null)

const fetchData = async () => {
  loading.value = true
  try {
    const params = { page: pagination.current_page, per_page: pagination.per_page }
    if (searchQuery.value) params.search = searchQuery.value
    if (filterCategory.value) params.category = filterCategory.value
    const r = await api.getPlayRecords(params)
    list.value = r.data || []
    pagination.current_page = r.pagination?.current_page || 1
    pagination.total = r.pagination?.total || 0
    // 收集品类选项
    const cats = new Set()
    ;(r.data || []).forEach(item => { if (item.category) cats.add(item.category) })
    categories.value = [...cats].sort()
  } catch {} finally { loading.value = false }
}

const showDialog = (edit, row) => {
  isEdit.value = edit
  if (row) {
    form.value = { ...defaultForm(), ...row }
  } else {
    form.value = defaultForm()
  }
  dialogVisible.value = true
}

const handleSave = async () => {
  const valid = await formRef.value?.validate().catch(() => {})
  if (!valid) return
  saving.value = true
  try {
    if (isEdit.value) {
      await api.updatePlayRecord(form.value.id, form.value)
    } else {
      await api.createPlayRecord(form.value)
    }
    ElMessage.success('保存成功')
    dialogVisible.value = false
    await fetchData()
  } catch (e) {
    ElMessage.error('保存失败')
  } finally { saving.value = false }
}

const handleDelete = (row) => {
  ElMessageBox.confirm(`确定删除「${row.name}」的档案吗？`, '提示', { type: 'warning' }).then(async () => {
    try {
      await api.deletePlayRecord(row.id)
      ElMessage.success('已删除')
      await fetchData()
    } catch { ElMessage.error('删除失败') }
  }).catch(() => {})
}

onMounted(fetchData)
</script>

<style scoped>
.sub-cat-sep {
  margin: 0 4px;
  color: #999;
}
.sub-cat {
  color: #666;
  font-size: 13px;
}
.text-muted {
  color: #c0c4cc;
  font-size: 13px;
}
</style>
